"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateFilename = validateFilename;
exports.validatePath = validatePath;
exports.validateFileSize = validateFileSize;
exports.validateExtension = validateExtension;
exports.validateFileMetadata = validateFileMetadata;
const upload_constants_1 = require("./upload-constants");
function validateFilename(filename) {
    const errors = [];
    if (filename.includes('\x00')) {
        errors.push({
            path: filename,
            code: 'INVALID_FILENAME',
            message: 'Filename contains null bytes',
        });
    }
    if (/[\x00-\x1F]/.test(filename)) {
        errors.push({
            path: filename,
            code: 'INVALID_FILENAME',
            message: 'Filename contains control characters',
        });
    }
    if (filename.includes('..')) {
        errors.push({
            path: filename,
            code: 'PATH_TRAVERSAL',
            message: 'Filename contains path traversal pattern',
        });
    }
    const invalidChars = /[<>:"|?*]/;
    if (invalidChars.test(filename)) {
        errors.push({
            path: filename,
            code: 'INVALID_FILENAME',
            message: 'Filename contains invalid characters',
        });
    }
    return errors;
}
function validatePath(path) {
    const errors = [];
    if (path.includes('..')) {
        errors.push({
            path,
            code: 'PATH_TRAVERSAL',
            message: 'Path contains traversal pattern',
        });
    }
    const pathParts = path.split('/');
    for (const part of pathParts) {
        if (upload_constants_1.BLOCKED_DIRECTORIES.includes(part)) {
            errors.push({
                path,
                code: 'PATH_TRAVERSAL',
                message: `Path contains blocked directory: ${part}`,
            });
            break;
        }
    }
    if (pathParts.length > upload_constants_1.UPLOAD_LIMITS.MAX_PATH_DEPTH) {
        errors.push({
            path,
            code: 'PATH_TOO_DEEP',
            message: `Path depth exceeds maximum of ${upload_constants_1.UPLOAD_LIMITS.MAX_PATH_DEPTH}`,
        });
    }
    if (path.length > upload_constants_1.UPLOAD_LIMITS.MAX_PATH_LENGTH) {
        errors.push({
            path,
            code: 'PATH_TOO_LONG',
            message: `Path length exceeds maximum of ${upload_constants_1.UPLOAD_LIMITS.MAX_PATH_LENGTH}`,
        });
    }
    return errors;
}
function validateFileSize(size, filePath = '') {
    const errors = [];
    if (size > upload_constants_1.UPLOAD_LIMITS.MAX_FILE_SIZE_BYTES) {
        errors.push({
            path: filePath,
            code: 'FILE_TOO_LARGE',
            message: `File size ${size} exceeds maximum of ${upload_constants_1.UPLOAD_LIMITS.MAX_FILE_SIZE_BYTES}`,
        });
    }
    return errors;
}
function validateExtension(_filename, _cadTool) {
    return [];
}
function validateFileMetadata(params) {
    const errors = [];
    const { relativePath, size, cadTool } = params;
    errors.push(...validatePath(relativePath));
    const filename = relativePath.split('/').pop() ?? '';
    errors.push(...validateFilename(filename));
    errors.push(...validateFileSize(size, relativePath));
    errors.push(...validateExtension(filename, cadTool));
    return errors;
}
//# sourceMappingURL=upload-validators.js.map